module.exports = {
    extend: require('lodash/extend'),
    result: require('lodash/result'),
    pull: require('lodash/pull'),
    difference: require('lodash/difference'),
    assign: require('lodash/assign'),
    assignWith: require('lodash/assignWith'),
    eq: require('lodash/eq'),
    cloneDeep: require('lodash/cloneDeep'),
    clone: require('lodash/clone'),
    values: require('lodash/values'),
    keys: require('lodash/keys'),
    invert: require('lodash/invert'),
    isNumber: require('lodash/isNumber'),
    intersection: require('lodash/intersection'),
    range: require('lodash/range'),
    merge: require('lodash/merge'),
    isObject: require('lodash/isObject'),
    isEmpty: require('lodash/isEmpty'),
    isEqual: require('lodash/isEqual'),
    isArray: require('lodash/isArray')
};
